<template>
  <div>
    <div class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vs-tabs
          alignment="fixed"
          v-model="activeTab"
          class="tab-action-btn-fill-conatiner"
        >
          <vs-tab :label="$t('setup.label.Supplier')">
            <Supplier />
          </vs-tab>
          <vs-tab :label="$t('setup.label.ItemModel')">
            <ItemModel />
          </vs-tab>
          <vs-tab :label="$t('setup.label.Items')">
            <Items />
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import VxCard from "@/components/vx-card/VxCard.vue";
import Supplier from "./supplier.vue";
import Items from "./items/items.vue";
import ItemModel from "./item-model/itemModelList.vue";

export default {
  data() {
    return {
      activeTab: 0,
    };
  },
  components: {
    VxCard,
    Supplier,
    Items,
    ItemModel,
  },
};
</script>
